import axios from 'axios';

export default {
    init: () => {
        axios.post('/api/public/wxjsconfig', {
            url: window.location.href,
            apis: ['updateAppMessageShareData', 'onMenuShareAppMessage', 'scanQRCode', 'showMenuItems', 'previewImage']
        }).then(function(response) {
            if (response.data.signature) {
                wx.config(response.data);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/utils/wechatUtil.js